<template>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
        <v-container grid-list-xl>
            <v-layout wrap>
                <v-flex xs12>
                    <v-switch v-model="item.enable" :label="$t('Habilitado')" />
                </v-flex>
                <v-flex xs12>
                    <v-text-field :label="$t('Nome')" v-model="item.name" :rules="[rules.required, rules.min(5)]" />
                </v-flex>
                <v-flex xs12 mb-8>
                    <!-- <v-text-field v-model="item.crm" :rules="[rules.crmValidatorDigit]" label="CRM" v-mask="['##.##', '##.###', '##.####']" return-masked-value class="my-0 py-0" /> -->
                    <v-text-field label="CRM" :rules="[rules.crmValidatorDigit]" v-model="item.crm" class="my-0 py-0" />
                </v-flex>

                <v-flex xs12 md6>
                    <v-text-field v-model="item.cellphone" :rules="[rules.cellphone]" label="Celular" v-mask="['(##) ####-####', '(##) #####-####']" return-masked-value
                        class="my-0 py-0" />
                    <v-text-field v-model="item.phone" :rules="[rules.cellphone]" label="Telefone" v-mask="['(##) ####-####', '(##) #####-####']" return-masked-value
                        class="my-0 py-0" />
                    <v-text-field :label="$t('Procedencia')" v-model="item.origin" class="my-0 py-0" />
                </v-flex>

                <v-flex xs12 mt-8>
                    <Address :item="item" />
                </v-flex>

                <v-flex xs12>
                    <v-btn :loading="lock" :disabled="!valid" color="success" @click="validate">{{ $t("Salvar") }}</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";
import Address from "@/components/form/Address";

export default {
    directives: { mask },
    components: { Address },
    props: {
        itemToEdit: {
            type: Object,
        },
        lock: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            itemClean: {
                name: "",
                crm: "",
                phone: null,
                cellphone: null,
                cepOk: true,
                cep: "",
                state: "",
                city: "",
                district: "",
                address: "",
                houseNumber: "",
                complement: "",
                enable: true,
            },
            item: { ...this.itemClean },
            clients: null,
        };
    },

    watch: {
        itemToEdit: {
            immediate: true,
            handler(newVal) {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }

                this.$nextTick(() => {
                    if (newVal == null) {
                        this.item = { ...this.itemClean };
                    } else {
                        this.item = { ...newVal };
                    }
                });
            },
        },
    },

    methods: {
        getClients() {
            this.$http
                .get(`doctors`)
                .then((result) => {
                    if (result) {
                        this.clients = result;
                    }
                })
                .catch(() => {
                    this.clients = null;
                });
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.item);
            }
        },
    },

    mounted() {
        this.getClients();
        if (this.$refs.form) {
            this.$refs.form.reset();
        }
    },
};
</script>